import React from 'react'

const Enter = () => {
  return (
    <div className="display--flex justify--center" style={{marginTop: "5px", textAlign: "center"}}>
      <div style={{marginRight: "5px", marginTop: "2px"}}>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11">
            <g fill="none" fillRule="evenodd">
                <path fill="#F4F4F4" d="M-904-302H536V722H-904z"/>
                <g fill="#AAA" fillRule="nonzero">
                    <rect width="1" height="9" x="9" rx=".5"/>
                    <rect width="9" height="1" x="1" y="8" rx=".5"/>
                    <path d="M.068 8.609c-.09-.06-.09-.158 0-.218l3.536-2.346A.301.301 0 0 1 3.768 6c.128 0 .232.069.232.154v4.692c0 .041-.024.08-.068.109a.32.32 0 0 1-.328 0L.068 8.609z"/>
                </g>
            </g>
        </svg>
      </div>
      <div>
        <span className="fs--small-medium" style={{color: "#aaaaaa"}}>Enter</span>
      </div>
    </div>
  )
}

export default Enter


// WEBPACK FOOTER //
// ./src/components/checkIn/Enter.js